import React, { useState } from 'react';
import { db } from '../FirebaseComp/firebase'; // Assuming you have firebase.js configured
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './bookeyetestdisabled.css';

function BookAnEyeScreeningForDisabled() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    address: '',
    specialRequirements: '',
    status: 'pending'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');
    
    try {
      // Add a new document with a generated id
      const docRef = await addDoc(collection(db, "disabledAppointments"), {
        ...formData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      
      console.log("Document written with ID: ", docRef.id);
      setSubmitSuccess(true);
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        address: '',
        specialRequirements: '',
        status: 'pending'
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      setSubmitError('Failed to submit appointment. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="eye-screening-container">
      <header className="screening-header">
        <div className="header-content">
          <h1 className="header-title">Specialized Eye Care for Individuals with Disabilities</h1>
          <p className="header-subtitle">Book an Eye Screening</p>
          <div className="header-decoration"></div>
        </div>
      </header>

      <section className="screening-content">
        <div className="content-wrapper">
          <div className="form-intro">
      
            <p>Our specialized eye screening service is designed to accommodate all types of disabilities with the utmost care and professionalism.</p>
            <div className="benefits-list">
              <div className="benefit-item">
                <span className="benefit-icon">👁️</span>
                <span>Accessible examination rooms</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">🕒</span>
                <span>Extended appointment times</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">🧑‍⚕️</span>
                <span>Well-Trained specialists</span>
              </div>
            </div>
          </div>

          <form className="screening-form" onSubmit={handleSubmit}>
            {submitSuccess && (
              <div className="success-message">
                <p>Your appointment has been booked successfully!</p>
                <p>We'll contact you shortly to confirm the details.</p>
              </div>
            )}

            {submitError && (
              <div className="error-message">
                <p>{submitError}</p>
              </div>
            )}

            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Kamal Jayasinghe"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="kamal@gmail.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="077 456-7890"
                />
              </div>


              <div className="form-group">
                <label htmlFor="phone">Address *</label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  placeholder="address"
                />
              </div>


              <div className="form-group">
                <label htmlFor="date">Preferred Date *</label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                  min={new Date().toISOString().split('T')[0]}
                />
              </div>

              <div className="form-group">
                <label htmlFor="time">Preferred Time *</label>
                <input
                  type="time"
                  id="time"
                  name="time"
                  value={formData.time}
                  onChange={handleChange}
                  required
                  min="09:00"
                  max="17:00"
                />
              </div>

              <div className="form-group full-width">
                <label htmlFor="specialRequirements">Special Requirements</label>
                <textarea
                  id="specialRequirements"
                  name="specialRequirements"
                  value={formData.specialRequirements}
                  onChange={handleChange}
                  placeholder="Please let us know about any special accommodations you might need"
                  rows="3"
                ></textarea>
              </div>
            </div>

            <div className="form-footer">
              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Booking...' : 'Book Appointment'}
              </button>
              <p className="form-note">
                * Required fields. We respect your privacy and will never share your information.
              </p>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}

export default BookAnEyeScreeningForDisabled;